import React from "react";
import GroupsTab from "./groupsTab";
import GroupsActivityButton from "../components/groupsActivityButton";
const GroupInfoSection = (props) => {
  const { icon, title, subTitle, textFirstTab, textSecondTab, textThirdTab, webvrurl } =
    props;
  return (
    <div className="overflow-y-auto z-1 bg-[#002E0F] xl:px-32 lg:px-32 md:px-32 sm:px-10 px-10 h-full xl:py-10 lg:py-0 md:py-0 sm:py-0 py-0 relative min-h-[25rem]  lg:row-start-auto row-start-1 lg:mt-0 md:mt-0 sm:mt-20 mt-20">
      <div className="grid grid-cols-1 justify-between text-left 2xl:met-44 xl:mt-44 lg:mt-5 md:mt-5 sm:mt-5 mt-5 relative">
        <div className="pb-5 flex lg:justify-start md:justify-center sm:justify-center justify-center">
          <img loading="lazy" src={icon} className="lg:h-20 md:h-16 sm:h-14 h-14"></img>
        </div>
        <div className="text-[#82AB40] lg:text-7xl md:text-5xl sm:text-4xl text-4xl lg:text-left md:text-left sm:text-center text-center font-bold ">
          {title}
        </div>
        <div className="text-white lg:text-3xl md:text-xl sm:text-xl text-xl lg:text-left md:text-left sm:text-center text-center  mt-5 ">
          {subTitle}
        </div>
        <GroupsTab
          firstTab={textFirstTab}
          secondTab={textSecondTab}
          thirdTab={textThirdTab}
          webvrurl={webvrurl}
        ></GroupsTab>
      </div>
    </div>
  );
};

export default GroupInfoSection;
